import { render, staticRenderFns } from "./single-product.vue?vue&type=template&id=cc46a270&scoped=true&"
import script from "./single-product.vue?vue&type=script&lang=js&"
export * from "./single-product.vue?vue&type=script&lang=js&"
import style0 from "./single-product.vue?vue&type=style&index=0&id=cc46a270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc46a270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc46a270')) {
      api.createRecord('cc46a270', component.options)
    } else {
      api.reload('cc46a270', component.options)
    }
    module.hot.accept("./single-product.vue?vue&type=template&id=cc46a270&scoped=true&", function () {
      api.rerender('cc46a270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/single-product.vue"
export default component.exports